
import { Component, Vue, Prop } from "vue-property-decorator";
import ClosedPeriod from "../../../domain/restaurant/ClosedPeriod";
import HolidayDialog from "@/components/restaurant/holiday/HolidayDialog.vue";
import RoomClosedPeriodDialog from "@/components/restaurant/holiday/RoomClosedPeriodDialog.vue";
import Room from "@/domain/restaurant/Room";
import Restaurant from "@/domain/restaurant/Restaurant";
@Component({
  components: { RoomClosedPeriodDialog, HolidayDialog }
})
export default class ClosedPeriodCard extends Vue {
  @Prop({
    default: function() {
      return new ClosedPeriod();
    }
  })
  closedPeriod!: ClosedPeriod;

  dialog = false;

  @Prop({ default: null })
  room!: Room | null;

  @Prop({ default: null })
  restaurant!: Restaurant | null;

  get isHoliday() {
    return this.restaurant != null;
  }

  get creationMessage() {
    if (this.isHoliday) return this.$t("holiday.create.message");
    else return this.$t("closedPeriod.create.message");
  }

  showDialog() {
    this.dialog = true;
  }

  get newClosedPeriod() {
    return this.closedPeriod.closedPeriodId == null;
  }

  addClosedPeriod(newClosedPeriod: ClosedPeriod) {
    this.$emit("new-closed-period", newClosedPeriod);
  }

  removeClosedPeriod(toRemove: ClosedPeriod) {
    this.$emit("delete-closed-period", toRemove);
  }
}
